"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var FilterOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M750.336 106.667H252.331a128 128 0 00-90.496 218.517l179.498 179.499v322.282A128 128 0 00526.571 941.44l85.333-42.667A128 128 0 00682.667 784.3v-300.95l158.165-158.165a128 128 0 00-90.496-218.517zm0 85.333a42.667 42.667 0 0130.165 72.832L622.336 422.997a85.333 85.333 0 00-25.003 60.352V784.3a42.667 42.667 0 01-23.594 38.165l-85.334 42.667a42.667 42.667 0 01-61.738-38.187v-322.24a85.333 85.333 0 00-25.003-60.352L222.165 264.853A42.667 42.667 0 01252.331 192h498.005z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
FilterOutlined.displayName = "FilterOutlined";
var _default = exports["default"] = FilterOutlined;